import { logErrorAndReport } from './errorReporting';
import { AcuityAppointmentTag, GroupClassFilteringCategory } from './scheduling/types';
import { Auth } from './user/types';

export enum StorageKeys {
  AppointmentTag = 'appointment-tag',
  AuthKey = 'member-auth',
  GroupClassesFilters = 'group-classes-filters',
  TelemedicineSchedulingId = 'telemedicine-scheduling-id',
}

export const storeAuth = (auth: Auth): void => {
  localStorage.setItem(StorageKeys.AuthKey, JSON.stringify(auth));
};

export const getAuth = (): Auth | null => {
  const auth = localStorage.getItem(StorageKeys.AuthKey);

  return auth ? (JSON.parse(auth) as Auth) : null;
};

export const trackAppointmentTagForCurrentSession = (tag: AcuityAppointmentTag): void => {
  sessionStorage.setItem(StorageKeys.AppointmentTag, tag);
};

export const getAppointmentTagForCurrentSession = (): AcuityAppointmentTag => {
  return sessionStorage.getItem(StorageKeys.AppointmentTag) as AcuityAppointmentTag;
};

export const storeGroupClassFilters = (filters: {
  category: GroupClassFilteringCategory | 'all';
}): void => {
  const existingFilters = getGroupClassFilters();

  localStorage.setItem(
    StorageKeys.GroupClassesFilters,
    JSON.stringify({ ...(existingFilters || {}), category: filters.category })
  );
};

export const getGroupClassFilters = (): {
  category: GroupClassFilteringCategory | 'all';
} | null => {
  const filters = localStorage.getItem(StorageKeys.GroupClassesFilters);

  return filters ? JSON.parse(filters) : null;
};

export const getItem = (key: StorageKeys): string | number | null => {
  const value = localStorage.getItem(key);

  try {
    if (value) {
      return JSON.parse(value);
    }

    return null;
  } catch (error) {
    logErrorAndReport({ error, isReportable: false });

    return value;
  }
};

export const setItem = (key: StorageKeys, value: string | number): void => {
  return localStorage.setItem(key, JSON.stringify(value));
};
